import { buildCandidateCompanyProfilesURI, useConfig } from '@seek/libs-shared';
import {
  Box,
  ButtonLink,
  Heading,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import { useEffect } from 'react';
import { DEFAULT_VARIANT_SCHEMA_VERSION } from '../../../shared/constants/launchDarklyFeatureFlags';
import {
  CURRENT_PAGE_EVENT_SUBMISSION,
  trackClickSubmissionPageGoToCompanyProfile,
  trackDisplayPage,
} from '../../../shared/tracking/writeAReview/trackingEvents';
import { type ReviewFormContext } from '../../type';
import { SuccessHiFiveImage } from '../SuccessHiFiveImage';

export const SubmitSuccessPage = ({
  reviewFormContext,
}: {
  companyName: string;
  reviewFormContext: ReviewFormContext;
  companyId?: string;
}) => {
  const config = useConfig();
  const { environment, country, language } = config;

  useEffect(() => {
    if (reviewFormContext?.variant) {
      trackDisplayPage({
        config,
        context: reviewFormContext,
        currentPage: CURRENT_PAGE_EVENT_SUBMISSION,
        variant: reviewFormContext?.variant ?? DEFAULT_VARIANT_SCHEMA_VERSION,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reviewFormContext?.variant]);

  const url = buildCandidateCompanyProfilesURI({
    country,
    language,
    isStaging: environment === 'staging',
  });

  const handleClick = () => {
    trackClickSubmissionPageGoToCompanyProfile({
      config,
      context: reviewFormContext,
    });
  };

  return (
    <Box
      data={{ testid: 'submit-success-page' }}
      paddingTop={{
        tablet: 'xxlarge',
        mobile: 'large',
      }}
    >
      <Stack space="xlarge" align="center">
        <Heading level="1">Thank you!</Heading>
        <Text size="standard">
          Your anonymous review helps us improve our platform and may be
          published on our website.
        </Text>

        <SuccessHiFiveImage />

        <Inline space="medium" collapseBelow="tablet">
          <ButtonLink
            variant="solid"
            tone="formAccent"
            onClick={handleClick}
            href={url}
            data={{ testid: 'go-to-company-profile' }}
          >
            Explore companies
          </ButtonLink>
        </Inline>
      </Stack>
    </Box>
  );
};
